module.exports = __webpack_public_path__ + "img/maestro.bf6b1974.svg";